import ky from 'ky';
export const tipsRedaksjonen = {
    name: "redaksjonen i Stavanger Aftenblad",
    image: "https://cdn.aftenbladet.no/rnd/opinion/sa.png",
    email: "tips@aftenbladet.no",
    phone: "05150",
    text: "Er du på stedet? Har du tips, bilder eller video? Her kan du komme i kontakt med oss. Vi belønner tips og bilder som blir brukt."
};
export const allJournalists = async () => {
    const { data } = await ky.get('https://sa-vof-api-2.herokuapp.com/sheet/1UbU1ub19tPhdjG5EluOCXowa5Yn4YWbKzWfmt2qdL2o').json();
    let restructure = data.map(j => {
        const imageUrl = j.image ? `https://cdn.aftenbladet.no/sa/portrett/square/${j.image}.jpg` : undefined;
        return {
            name: j.Navn,
            image: imageUrl,
            email: j.epost,
            phone: j.tlf
        };
    });
    restructure.push(tipsRedaksjonen);
    return restructure;
};
export const journalists = [
    {
        name: 'Camilla Bjørheim',
        image: 'https://cdn.aftenbladet.no/sa/portrett/square/camilla-bjorheim.jpg',
        email: 'camilla.bjorheim@aftenbladet.no',
        phone: '+47 905 00 00',
    },
    {
        name: 'Julie Teresa Olsen',
        image: 'https://cdn.aftenbladet.no/sa/portrett/square/julie-teresa-olsen.jpg',
        email: 'julie.teresa.olsen@aftenbladet.no',
        phone: '+47 905 00 01',
    },
    {
        name: 'Klaus Gustafsson',
        image: 'https://cdn.aftenbladet.no/sa/portrett/square/klaus-gustafsson.jpg',
        email: 'klaus.gustafsson@aftenbladet.no',
        phone: '+47 905 00 02',
    },
    {
        name: 'Håkon Åreskjold',
        image: 'https://cdn.aftenbladet.no/sa/portrett/square/camilla-bjorheim.jpg',
        email: 'hakon.areskjold@aftenbladet.no',
        phone: '+4791810142',
    }
];
